// extracted by mini-css-extract-plugin
module.exports = {"handle":"handle--1W9rd","label":"label--1KnHa","dragging":"dragging--24klB"};